import React from 'react';
import { useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';

const SKILL_KEY = 'Reading & Writing';

const PART_STYLES = [
  { bg: 'linear-gradient(135deg, #fffbeb, #fef3c7)', icon: '#f59e0b', border: '#fde68a', dot: '#f59e0b' },
  { bg: 'linear-gradient(135deg, #fff7ed, #ffedd5)', icon: '#f97316', border: '#fed7aa', dot: '#f97316' },
  { bg: 'linear-gradient(135deg, #fdf4ff, #f3e8ff)', icon: '#a855f7', border: '#ddd6fe', dot: '#a855f7' },
  { bg: 'linear-gradient(135deg, #eef2ff, #e0e7ff)', icon: '#6366f1', border: '#c7d2fe', dot: '#6366f1' },
  { bg: 'linear-gradient(135deg, #ecfdf5, #d1fae5)', icon: '#10b981', border: '#a7f3d0', dot: '#10b981' },
  { bg: 'linear-gradient(135deg, #f0fdf4, #dcfce7)', icon: '#22c55e', border: '#bbf7d0', dot: '#22c55e' },
  { bg: 'linear-gradient(135deg, #fff1f2, #ffe4e6)', icon: '#f43f5e', border: '#fecdd3', dot: '#f43f5e' },
];

const ReadingAndWritingGrid = () => {
  const navigate = useNavigate();
  const apiUrl = `${process.env.REACT_APP_API_URL}/exercises/exercise-types?skill=reading_writing`;
  const { data: apiResponse, loading, error } = useFetch(apiUrl);

  if (loading) return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {[1, 2, 3, 4, 5].map(i => (
        <div key={i} style={{
          height: 88, borderRadius: 20,
          background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)',
          backgroundSize: '400px 100%',
          animation: 'shimmer 1.4s infinite',
        }} />
      ))}
    </div>
  );

  if (error) return (
    <div style={{ textAlign: 'center', padding: '40px 20px', color: '#ef4444' }}>
      <div style={{ fontSize: 40, marginBottom: 8 }}>😕</div>
      <p style={{ fontWeight: 600 }}>Không tải được danh sách bài tập.</p>
    </div>
  );

  const parts = apiResponse || [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {parts.map((part, index) => {
        const style = PART_STYLES[index % PART_STYLES.length];
        return (
          <div
            key={part.id}
            onClick={() => navigate(`/skill-practice/part/${part.id}`)}
            style={{
              background: style.bg,
              border: `2px solid ${style.border}`,
              borderRadius: 20,
              padding: '18px 22px',
              cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: 18,
              transition: 'all 0.2s ease',
              boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.05)';
            }}
          >
            {/* Part number badge */}
            <div style={{
              width: 48, height: 48, borderRadius: 14, flexShrink: 0,
              background: 'white',
              border: `2px solid ${style.border}`,
              display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center',
              boxShadow: `0 4px 12px ${style.dot}22`,
            }}>
              <span style={{ fontSize: 10, fontWeight: 700, color: style.icon, lineHeight: 1 }}>Part</span>
              <span style={{ fontSize: 18, fontWeight: 900, color: style.icon, lineHeight: 1 }}>{index + 1}</span>
            </div>

            {/* Content */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 800, fontSize: 15, color: '#1e293b', marginBottom: 3 }}>
                {part.name}
              </div>
              {part.description && (
                <div style={{
                  fontSize: 13, color: '#64748b', lineHeight: 1.4,
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '90%',
                }}>
                  {part.description}
                </div>
              )}
            </div>

            {/* Arrow */}
            <div style={{
              width: 36, height: 36, borderRadius: '50%', flexShrink: 0,
              background: 'white', border: `2px solid ${style.border}`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: style.icon, fontWeight: 900, fontSize: 18,
            }}>
              →
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ReadingAndWritingGrid;